import { Divider } from '@mantine/core'

import { useLocation } from '@redwoodjs/router'

import AdverseActionsCard from './AdverseActionsCard'
import CommunicationsCard from './CommunicationsCard'
import CustomFieldsList from './CustomFieldsList'
import DocumentIntelligenceCard from './DocumentIntelligenceCard'
import EmploymentVerificationsCard, {
  EMPLOYMENT_VERIFICATIONS_SECTION,
} from './EmploymentVerificationsCard'
import ExpirationNotificationsCard from './ExpirationNotificationsCard'
import GeneralInformationCard from './GeneralInformationCard'
import NotificationsCard from './NotificationsCard'
import TagsList from './TagsList'

const CompanyDetailsPage = ({
  company = null,
  recruiters = [],
  initialLoading = false,
}) => {
  const { search } = useLocation()
  const section = new URLSearchParams(search).get('section')

  return (
    <div className="flex h-full flex-col gap-4 overflow-auto pb-6">
      <div className="flex items-center justify-between">
        <div className="text-base font-medium">Company Settings</div>
      </div>
      <Divider />

      <GeneralInformationCard
        companyData={{
          companyId: company?.companyId || '',
          companyName: company?.companyName || '',
          einNumber: company?.einNumber || '',
          dotNumber: company?.dotNumber || '',
          companySlug: company?.companySlug || '',
          companyPhoneNumber: company?.companyPhoneNumber || '',
          companyFaxNumber: company?.companyFaxNumber || '',
          address: company?.address || {
            addressId: '',
            street: '',
            city: '',
            state: '',
            country: '',
            zipCode: '',
          },
        }}
        initialOpened={true}
      />

      <CommunicationsCard
        companyData={{
          companyId: company?.companyId || '',
          phoneNumber: company?.phoneNumber || '',
          useRecruiterLine: company?.useRecruiterLine ?? true,
          callRecordingsEnabled: company?.callRecordingsEnabled ?? true,
          transcriptionEnabled: company?.transcriptionEnabled ?? true,
        }}
        initialOpened={true}
      />

      <NotificationsCard
        companyData={{
          companyId: company?.companyId || '',
          atsEnabled: company?.atsEnabled ?? true,
          recruiterLeadEmailNotifyEnabled:
            company?.recruiterLeadEmailNotifyEnabled ?? false,
          sendIncomingTextNotification:
            company?.sendIncomingTextNotification ?? false,
        }}
        initialOpened={true}
      />

      {company && <TagsList />}
      {company && <CustomFieldsList />}

      <EmploymentVerificationsCard
        companyData={{
          companyId: company?.companyId || '',
          incomingVoEAssignedEmployees: company?.incomingVoEAssignedEmployees,
          outgoingVoEAssignedEmployees: company?.outgoingVoEAssignedEmployees,
          voeVerificationPeriodMonths: company?.voeVerificationPeriodMonths,
          autoCancelOutOfWindowVoEs: company?.autoCancelOutOfWindowVoEs,
          atsEmailTrackingEnabled: company?.atsEmailTrackingEnabled,
          atsInboundEmailAddress: company?.atsInboundEmailAddress,
        }}
        recruiters={recruiters}
        initialLoading={initialLoading}
        focused={section === EMPLOYMENT_VERIFICATIONS_SECTION}
      />

      <ExpirationNotificationsCard
        companyData={{
          companyId: company?.companyId || '',
          expirationTrackingEnabled:
            company?.expirationTrackingEnabled ?? false,
        }}
      />

      <DocumentIntelligenceCard
        companyData={{
          companyId: company?.companyId || '',
          documentIntelligenceEnabled:
            company?.documentIntelligenceEnabled ?? false,
        }}
      />

      <AdverseActionsCard
        companyData={{
          companyId: company?.companyId || '',
          preAdverseActionDelayHours: company?.preAdverseActionDelayHours ?? 24,
          finalAdverseActionDelayHours:
            company?.finalAdverseActionDelayHours ?? 120,
        }}
      />
    </div>
  )
}

export default CompanyDetailsPage
